import sanitizeHtml from 'sanitize-html';

const allowedIframeHosts = new Set([
    'www.youtube.com',
    'youtube.com',
    'www.youtube-nocookie.com',
    'youtube-nocookie.com',
    'youtu.be',
]);

const isAllowedIframeSrc = (src?: string) => {
    if (!src) return false;
    try {
        const parsed = new URL(src);
        if (parsed.protocol !== 'https:') return false;
        return allowedIframeHosts.has(parsed.hostname.toLowerCase());
    } catch {
        return false;
    }
};

// 기본 sanitize-html 설정
export const defaultSanitizeConfig: sanitizeHtml.IOptions = {
    allowedTags: sanitizeHtml.defaults.allowedTags.concat([
        'img', 'span', 'table', 'tr', 'td', 'th',
        'thead', 'tbody', 'tfoot', 'col', 'colgroup', 'caption'
        , 'iframe'
    ]),
    allowedAttributes: {
        '*': ['style', 'class'], // 모든 태그에 style과 class 속성 허용
        img: ['src', 'srcset', 'alt', 'title', 'width', 'height', 'loading'],
        a: ['href', 'name', 'target'],
        iframe: ['src', 'title', 'width', 'height', 'allow', 'allowfullscreen', 'frameborder'],
        table: ['border', 'cellpadding', 'cellspacing', 'width', 'height'],
        tr: ['height'],
        td: ['colspan', 'rowspan', 'width', 'height', 'align', 'valign', 'class'],
        th: ['colspan', 'rowspan', 'width', 'height', 'align', 'valign', 'scope', 'class'],
        col: ['span', 'width'],
        colgroup: ['span', 'width'],
        tbody: [],
        thead: [],
        tfoot: [],
    },
    allowedSchemes: ['http', 'https', 'mailto'],
    allowedSchemesAppliedToAttributes: ['href', 'src'],
    allowedSchemesByTag: {
        a: ['http', 'https', 'mailto'],
        img: ['http', 'https', 'data'],
        iframe: ['https'],
    },
    allowProtocolRelative: false,
    exclusiveFilter: (frame) => {
        if (frame.tag !== 'iframe') {
            return false;
        }
        return !isAllowedIframeSrc(frame.attribs?.src);
    },
    parseStyleAttributes: false // 브라우저 환경에서 스타일 파싱 비활성화
};

// 공통 sanitize 함수
export const sanitizeContent = (dirty: string, customConfig?: Partial<sanitizeHtml.IOptions>): string => {
    const config = customConfig ? { ...defaultSanitizeConfig, ...customConfig } : defaultSanitizeConfig;
    return sanitizeHtml(dirty, config);
};

// 특정 용도별 설정들
export const strictSanitizeConfig: sanitizeHtml.IOptions = {
    ...defaultSanitizeConfig,
    allowedTags: ['p', 'br', 'strong', 'em', 'u', 'b', 'i'],
    allowedAttributes: {
        '*': ['style']
    }
};

export const tableFriendlyConfig: sanitizeHtml.IOptions = {
    ...defaultSanitizeConfig,
    // 이미 기본 설정에 테이블 관련 설정이 포함되어 있음
};